<template>
  <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex">
    <div class="card requested mb-4 h-auto calculation-card">
      <div
        v-if="deletable"
        class="calculation-card__button"
      >
        <button
          class="btn btn-danger btn-sm"
          @click="onDelete"
        >
          <i class="fa fa-trash"></i>
        </button>
      </div>
      <img
        :src="lead.image"
        :alt="lead.id"
        class="calculation-card__image card-img-top"
      >

      <div class="card-body d-flex flex-column">
        <h3 class="card-title">
          {{ lead.name }} <br>
          {{ lead.type_name }}
        </h3>
        <p class="card-text">
          Igénylés dátuma: <br><strong>{{ lead.created_at }}</strong>
        </p>
        <p class="card-text">
          Mentés azonosítója: <br><strong>{{ lead.id }}</strong>
        </p>
        <p class="card-text mb-4">
          Havidíj: <br><strong>{{ lead.price }} Ft</strong>
        </p>
        <div class="row mt-auto">
          <div class="col-6 text-left">
            <a
                :href="lead.url"
                class="btn btn-block btn-outline-secondary btn-sm"
            >
              Részletek
            </a>
          </div>
          <div
            v-if="saved"
            class="col-6 text-right"
          >
            <a
              href="#"
              class="btn btn-block btn-primary btn-sm"
            >
              Igénylés
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Component, Prop, Vue } from 'vue-property-decorator';

  @Component
  export default class LeadCard extends Vue {
    @Prop(Boolean) saved;
    @Prop(Boolean) deletable;
    @Prop(Object) lead;

    onDelete() {
      this.$emit('delete', this.lead);
    }
  }
</script>
